export default __webpack_public_path__ + "images/5Y.5f95c8d.png";